import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';

import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';

import Question from '../Views/Question';
import Modal from '../Modals/Modal';
import Select from '../App/Select';

import { videoExerciseValidationSchema } from '../../utils/util';
import { VIDEO_TYPES, TASK_TYPES, VIDEO_URL_ROUTES } from '../../utils/constants';

const useStyles = makeStyles((theme) => {
  return {
    formControl: {
      marginBottom: 15,
    },
    paper: {
      padding: 30,
      marginBottom: 15,
      boxShadow: theme.boxShadow,
    },
    modifyContainer: {
      marginBottom: 0,
    },
    title: {
      marginBottom: 15,
    },
  };
});

export default function VideoTask(props) {
  const {
    videoExercise, setSnack, pageRefresh, setLoading, insertOrUpdateVideoExercise,
  } = props;
  const classes = useStyles();

  const getInitialState = (obj = {}) => {
    return {
      _id: obj._id,
      name: obj.name || '',
      url: obj.url || '',
      quizes: obj.quizes || [],
      route: obj.route || '',
      type: obj.type || '',
    };
  };

  const [data, setData] = React.useState(getInitialState());
  const [openModal, setOpenModal] = React.useState(false);
  const [editQuiz, setEditQuiz] = React.useState({});
  const [editQuizIndex, setEditQuizIndex] = React.useState(-1);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    if (name === 'type') {
      const quizes = value === TASK_TYPES.VIDEO_URL ? [] : data.quizes;
      const route = value === TASK_TYPES.VIDEO ? '' : data.route;
      setData((prevData) => {
        return {
          ...prevData, quizes, route, [name]: value,
        };
      });
    } else {
      setData((prevData) => {
        return { ...prevData, [name]: value };
      });
    }
  };

  const onClose = () => {
    setEditQuizIndex({});
    setEditQuizIndex(-1);
    setOpenModal(false);
  };

  const handleQuizesChange = (quizObj) => {
    const quizes = data.quizes;
    if (quizes[editQuizIndex]) quizes[editQuizIndex] = quizObj;
    else quizes.push(quizObj);
    setData((prevData) => {
      return { ...prevData, quizes };
    });
    onClose();
  };

  const handleQuizChange = (quizObj, index) => {
    setEditQuiz(quizObj);
    setEditQuizIndex(index);
    setOpenModal(true);
  };

  const deleteQuize = (index) => {
    if (index === undefined || index === null) return;
    const quizes = data.quizes;
    quizes.splice(index, 1);
    setData((prevData) => {
      return { ...prevData, quizes };
    });
  };

  const setOpen = () => {
    setEditQuiz({});
    setOpenModal(true);
  };

  const submit = () => {
    setLoading(true);
    videoExerciseValidationSchema.validate(data)
      .then(() => { return insertOrUpdateVideoExercise(data); })
      .then(() => {
        setSnack({
          open: true,
          severity: 'success',
          message: `Video Exercise ${data._id ? 'Updated' : 'Added'} Successfully.`,
        });
        setLoading(false);
        setData(getInitialState());
        pageRefresh();
      }).catch((err) => {
        setSnack({
          open: true,
          severity: 'error',
          message: err.message || (err.error.response.data && err.error.response.data.message) || 'Something went wrong',
        });
        setLoading(false);
      });
  };

  React.useEffect(() => {
    if (videoExercise) setData(getInitialState(videoExercise));
  }, [videoExercise]);

  return (
    <div>
      <Modal open={openModal} handleClose={onClose} title="Quiz">
        <Question
          quizObj={editQuiz}
          handleQuizesChange={handleQuizesChange}
          setSnack={setSnack}
        />
      </Modal>
      <Grid>
        <Paper className={classes.paper} elevation={0}>
          <Select
            title="Video Type"
            data={VIDEO_TYPES || []}
            name="type"
            value={data.type}
            handleChange={handleChange}
          />
          <FormControl fullWidth variant="outlined" className={classes.formControl}>
            <TextField
              type="text"
              onChange={handleChange}
              label="Enter Name"
              variant="outlined"
              name="name"
              value={data.name}
            />
          </FormControl>
          <FormControl fullWidth variant="outlined" className={classes.formControl}>
            <TextField
              type="text"
              onChange={handleChange}
              label="Enter URL"
              variant="outlined"
              name="url"
              value={data.url}
            />
          </FormControl>
          {
            data.quizes.map((quizObj, index) => {
              return (
                // eslint-disable-next-line react/no-array-index-key
                <Grid key={index}>
                  <Grid container className={classes.modifyContainer} justify="flex-end">
                    <IconButton onClick={() => { deleteQuize(index); }}><DeleteIcon fontSize="small" /></IconButton>
                    <IconButton onClick={() => { handleQuizChange(JSON.parse(JSON.stringify(quizObj)), index); }}>
                      <EditIcon fontSize="small" />
                    </IconButton>
                  </Grid>
                  <Grid className={classes.formControl}>
                    <Question
                      index={index}
                      quizObj={quizObj}
                      disabled
                    />
                  </Grid>
                </Grid>
              );
            })
          }
          {
            data.type === TASK_TYPES.VIDEO
              ? (
                <Grid container justify="flex-end">
                  <Button size="small" variant="contained" onClick={setOpen} startIcon={<AddIcon />}>Add quiz</Button>
                </Grid>
              ) : null
          }
          {
            data.type === TASK_TYPES.VIDEO_URL
              ? (
                <Select
                  title="Route"
                  data={VIDEO_URL_ROUTES || []}
                  name="route"
                  value={data.route}
                  handleChange={handleChange}
                />
              ) : null
          }
          <Button variant="contained" color="primary" onClick={submit}>
            <b>
              {data._id ? 'Update' : 'Add'}
              {' '}
              Exercise
            </b>
          </Button>
        </Paper>
      </Grid>
    </div>
  );
}
